import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { showError } from '../../toast';
import { api, UTILITY_LABELS } from '../../api';
import { t } from '../../i18n';
import { Button, Card, COLORS, Input, Label, Muted, Screen, Title } from '../../ui';

export default function AddUtilityAccountScreen({ route, navigation }: any) {
  const { apartmentId } = route.params;
  const [type, setType] = useState('ELECTRICITY');
  const [providerName, setProviderName] = useState('');
  const [clientNumber, setClientNumber] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await api(`/apartments/${apartmentId}/utility-accounts`, {
        body: { type, clientNumber, ...(providerName ? { providerName } : {}) },
      });
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('ИТН / клиентски номер')}</Title>
      <Card>
        <Muted>{t('Номерата са видими за наемателя, когато той плаща сметките сам.')}</Muted>
        <Label>{t('Услуга')}</Label>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
          {Object.entries(UTILITY_LABELS).map(([key, label]) => (
            <Pressable
              key={key}
              onPress={() => setType(key)}
              style={{
                paddingHorizontal: 12,
                paddingVertical: 8,
                borderRadius: 8,
                backgroundColor: type === key ? COLORS.primary : COLORS.bg,
                borderWidth: 1,
                borderColor: type === key ? COLORS.primary : COLORS.border,
              }}
            >
              <Text style={{ color: type === key ? '#fff' : COLORS.text }}>{t(label)}</Text>
            </Pressable>
          ))}
        </View>
        <Label>{t('Доставчик (по избор)')}</Label>
        <Input value={providerName} onChangeText={setProviderName} placeholder={t('Електрохолд')} />
        <Label>{t('ИТН / клиентски номер')}</Label>
        <Input value={clientNumber} onChangeText={setClientNumber} placeholder="1002003004" />
        <Button title={t('Запази')} onPress={submit} disabled={!clientNumber} loading={loading} />
      </Card>
    </Screen>
  );
}
